/**
 * Admin dashboard access control (client-side gate).
 *
 * Mirrors convex/lib/adminAccess.ts. There is exactly one admin account for
 * the business dashboard — a hard-coded equality check, not the Clerk
 * `publicMetadata.isAdmin` flag used elsewhere (nothing sets that flag) and
 * not the `specialPermissions` role table (built for an expandable set of
 * roles; a single named owner does not need it).
 *
 * This check is a UX convenience only — every Convex query/mutation the
 * dashboard calls re-checks the identity server-side.
 */

export const ADMIN_EMAIL = 'support@infinityvaultcards.com';

export function isAdminEmail(email: string | null | undefined): boolean {
  return !!email && email.toLowerCase() === ADMIN_EMAIL.toLowerCase();
}
